import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { HomeIcon, BuildingIcon, ConstructionIcon, SettingsIcon, LogOutIcon, DollarSignIcon, FileTextIcon, PencilIcon, ListTodoIcon, HistoryIcon } from 'lucide-react';
import { useFilter } from './context/FilterContext';
const Layout = () => {
  const {
    strategyFilter,
    setStrategyFilter
  } = useFilter();
  const location = useLocation();
  // Only show the filter on pages that display properties
  const showFilter = ['/', '/properties'].includes(location.pathname) || location.pathname.startsWith('/properties/');
  return <div className="flex h-screen bg-gray-50" data-id="element-822">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-gray-200" data-id="element-823">
        <div className="p-6" data-id="element-824">
          <h1 className="text-xl font-bold text-gray-900" data-id="element-825">Fliptec Pro</h1>
        </div>
        <nav className="mt-6" data-id="element-826">
          <NavLink to="/" end className={({
          isActive
        }) => `flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 ${isActive ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600' : ''}`} data-id="element-827">
            <HomeIcon className="w-5 h-5 mr-3" data-id="element-828" />
            <span data-id="element-829">Dashboard</span>
          </NavLink>
          <NavLink to="/properties" className={({
          isActive
        }) => `flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 ${isActive ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600' : ''}`} data-id="element-830">
            <BuildingIcon className="w-5 h-5 mr-3" data-id="element-831" />
            <span data-id="element-832">Properties</span>
          </NavLink>
          <NavLink to="/projects" className={({
          isActive
        }) => `flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 ${isActive ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600' : ''}`} data-id="element-833">
            <ConstructionIcon className="w-5 h-5 mr-3" data-id="element-834" />
            <span data-id="element-835">Projects</span>
          </NavLink>
          <NavLink to="/deal-input" className={({
          isActive
        }) => `flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 ${isActive ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600' : ''}`} data-id="element-836">
            <DollarSignIcon className="w-5 h-5 mr-3" data-id="element-837" />
            <span data-id="element-838">Deal Analysis</span>
          </NavLink>
          <NavLink to="/deal-history" className={({
          isActive
        }) => `flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 ${isActive ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600' : ''}`} data-id="element-839">
            <HistoryIcon className="w-5 h-5 mr-3" data-id="element-840" />
            <span data-id="element-841">Deal History</span>
          </NavLink>
          <NavLink to="/file-cabinet" className={({
          isActive
        }) => `flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 ${isActive ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600' : ''}`} data-id="element-842">
            <FileTextIcon className="w-5 h-5 mr-3" data-id="element-843" />
            <span data-id="element-844">File Cabinet</span>
          </NavLink>
          <NavLink to="/notes" className={({
          isActive
        }) => `flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 ${isActive ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600' : ''}`} data-id="element-845">
            <PencilIcon className="w-5 h-5 mr-3" data-id="element-846" />
            <span data-id="element-847">Notes & Logs</span>
          </NavLink>
          <NavLink to="/todos" className={({
          isActive
        }) => `flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 ${isActive ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600' : ''}`} data-id="element-848">
            <ListTodoIcon className="w-5 h-5 mr-3" data-id="element-849" />
            <span data-id="element-850">To-Do List</span>
          </NavLink>
        </nav>
        <div className="absolute bottom-0 w-64 border-t border-gray-200" data-id="element-851">
          <div className="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 cursor-pointer" data-id="element-852">
            <SettingsIcon className="w-5 h-5 mr-3" data-id="element-853" />
            <span data-id="element-854">Settings</span>
          </div>
          <div className="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 cursor-pointer" data-id="element-855">
            <LogOutIcon className="w-5 h-5 mr-3" data-id="element-856" />
            <span data-id="element-857">Logout</span>
          </div>
        </div>
      </aside>
      {/* Main Content */}
      <main className="flex-1 overflow-auto" data-id="element-858">
        {showFilter && <div className="bg-white border-b border-gray-200 px-6 py-3" data-id="element-859">
            <div className="flex items-center justify-between" data-id="element-860">
              <div className="flex items-center" data-id="element-861">
                <span className="text-sm font-medium text-gray-700 mr-3" data-id="element-862">
                  Property Strategy:
                </span>
                <div className="flex space-x-2" data-id="element-863">
                  <button onClick={() => setStrategyFilter('All')} className={`inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md ${strategyFilter === 'All' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-864">
                    <div className="w-4 h-4 mr-1.5" data-id="element-865" />
                    All Properties
                  </button>
                  <button onClick={() => setStrategyFilter('Long-Term Hold')} className={`inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md ${strategyFilter === 'Long-Term Hold' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-866">
                    <HomeIcon className="w-4 h-4 mr-1.5" data-id="element-867" />
                    Long-Term Holds
                  </button>
                  <button onClick={() => setStrategyFilter('Short-Term Flip')} className={`inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md ${strategyFilter === 'Short-Term Flip' ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-868">
                    <div className="w-4 h-4 mr-1.5" data-id="element-869" />
                    Flips
                  </button>
                </div>
              </div>
            </div>
          </div>}
        <div className="p-6" data-id="element-870">
          <Outlet data-id="element-871" />
        </div>
      </main>
    </div>;
};
export default Layout;